<template>
  <div>
    <div class="container" style="margin-top: 160px;">
      <div class="row">
        <div class="col-lg-2"></div>
      </div>
      <div class="row mt-5">
        <div class="col-lg-5"></div>
        <div class="spin-wrap">
          <h1 class="redirect-info">{{ redirect }}</h1>
          <div class="spinner sqLoad"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const CryptoJS = require('crypto-js')
import { env } from '@/env'
export default {
  metaInfo: {
    title: 'Validating',
    meta: [{ name: 'description', content: `Log in` }],
  },

  data() {
    return {
      redirect: 'Getting Token and Validating ...',
    }
  },

  created() {
    // Redirection of user
    var userInformation = this.getUserInfo()

    console.log('userInformation', userInformation)
    var roleId = userInformation
      ? userInformation.user_type_id.substring(0, 2)
      : null
    if (roleId === '11' || roleId === '14') {
      // Admin Role
      this.$router.push({ name: 'manage-vendor' })
    } else if (roleId === '18') {
      // Vendor Role
      this.$router.push({ name: 'vendorServicesForms' })
      // this.$router.push({ name: 'serviceRequestsVendor' })
      // this.$router.push({ name: 'landingPage' })
    } else if (roleId) {
      // Resident Role
      this.$router.push({ name: 'landingPage' })
    } else {
      // this.redirect = 'Unauthorized access '
      // window.console.log('Role Looping')
      this.$router.push({ name: 'authentication' })
    }
  },

  methods: {
    getUserInfo() {
      let secretKey = env.VUE_APP_SECRET_KEY
      if (!window.localStorage.getItem('auth.authToken')) {
        return false
      }
      try {
        const bytes = CryptoJS.AES.decrypt(
          window.localStorage.getItem('auth.authToken')
            ? window.localStorage.getItem('auth.authToken').toString()
            : '',
          secretKey
        )
        const serializedState = JSON.parse(bytes.toString(CryptoJS.enc.Utf8))

        if (serializedState === null) {
          return false
        } else {
          return serializedState
        }
      } catch (error) {
        return false
      }
    },
  },
}
</script>

<style scoped>
.align-center {
  text-align: center;
}

.spinner {
  width: 40px;
  height: 40px;
  background-color: #333;
  /* margin: 100px auto; */
  -webkit-animation: sk-rotateplane 1.2s infinite ease-in-out;
  animation: sk-rotateplane 1.2s infinite ease-in-out;
}
@-webkit-keyframes sk-rotateplane {
  0% {
    -webkit-transform: perspective(120px);
  }
  50% {
    -webkit-transform: perspective(120px) rotateY(180deg);
  }
  100% {
    -webkit-transform: perspective(120px) rotateY(180deg) rotateX(180deg);
  }
}
@keyframes sk-rotateplane {
  0% {
    transform: perspective(120px) rotateX(0deg) rotateY(0deg);
    -webkit-transform: perspective(120px) rotateX(0deg) rotateY(0deg);
  }
  50% {
    transform: perspective(120px) rotateX(-180.1deg) rotateY(0deg);
    -webkit-transform: perspective(120px) rotateX(-180.1deg) rotateY(0deg);
  }
  100% {
    transform: perspective(120px) rotateX(-180deg) rotateY(-179.9deg);
    -webkit-transform: perspective(120px) rotateX(-180deg) rotateY(-179.9deg);
  }
}

.sqLoad {
  background-color: #d13851;
  width: 40px;
  height: 40px;
}
.spin-wrap {
  position: fixed;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.2);
}
.redirect-info {
  font-size: 28px;
  text-align: center;
  margin-bottom: 15px;
  width: 100%;
  max-width: 360px;
}
@media (max-width: 576px) {
  .head-logo img {
    width: 100%;
  }
  .redirect-info {
    font-size: 22px;
  }
}
</style>
